// extracted by mini-css-extract-plugin
export var dataCell = "_na-2";
export var dataRow = "_na-0";
export var headerRow = "_na-1";